(function(){
  var MC_API   = "https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec";
  var MC_TOKEN = "mc_cc6f126b6aaf46bfa553068c22727813";
  var root = document.getElementById("mc-home");
  var $ = function(s){ return root.querySelector(s); };
  var dateRange = "7d";
  var liveTimer = null;

  function call(p){
    return new Promise(function(res,rej){
      var cb="mc_cb_"+Math.random().toString(36).slice(2),s=document.createElement("script"),
          to=setTimeout(function(){cl();rej(new Error("timeout"));},30000);
      function cl(){clearTimeout(to);try{delete window[cb];}catch(e){window[cb]=null;}}
      window[cb]=function(d){cl();res(d);};
      p.key=MC_TOKEN; p.callback=cb;
      s.src=MC_API+"?"+Object.keys(p).map(function(k){return encodeURIComponent(k)+"="+encodeURIComponent(p[k]);}).join("&");
      s.onerror=function(){cl();rej(new Error("erro de rede"));};
      document.head.appendChild(s);
    });
  }

  var BRL=function(v){return"R$ "+(+v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});};
  var NUM=function(v){return(+v||0).toLocaleString("pt-BR");};
  var PCT=function(v){return((+v||0)*100).toFixed(1).replace(".",",")+"%";};
  var esc=function(s){var d=document.createElement("div");d.textContent=String(s||"");return d.innerHTML;};
  function rangeLabel(r){var m={"hoje":"Hoje","hoje_ontem":"Hoje+Ontem","7d":"7 dias","30d":"30 dias","mes":"Mês","ano":"Ano","max":"Máximo"};return m[r]||r;}

  /* ===== rangepicker: calendário igual ao da página de Aquisição ===== */
  var MCH_MONTHS=['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
  var MCH_PRESET_LABEL={hoje:'Hoje',hoje_ontem:'Hoje+Ontem','7d':'7 dias','30d':'30 dias',ano:'Ano',max:'Máximo'};
  function setRange(r,label){
    dateRange=r;
    var lbl=$('#mch-range-label'); if(lbl) lbl.textContent=label||rangeLabel(r);
    load();
  }
  (function(){
    var container=$('#mch-cal'), toggle=$('#mch-range-toggle');
    if(!container||!toggle) return;
    function iso(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
    function br(d){ return ('0'+d.getDate()).slice(-2)+'/'+('0'+(d.getMonth()+1)).slice(-2); }
    function same(a,b){ return a&&b&&a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate(); }
    function presetKey(a,b){ var t=new Date(); t.setHours(0,0,0,0);
      var ea=iso(a), eb=iso(b), et=iso(t);
      if(ea===et&&eb===et) return 'hoje';
      if(ea===iso(new Date(t.getTime()-864e5))&&eb===et) return 'hoje_ontem';
      if(ea===iso(new Date(t.getTime()-6*864e5))&&eb===et) return '7d';
      if(ea===iso(new Date(t.getTime()-29*864e5))&&eb===et) return '30d';
      if(ea===iso(new Date(t.getFullYear(),0,1))&&eb===et) return 'ano';
      return null; }
    var st={view:null,start:null,end:null,open:false,grid:null,title:null,rng:null};
    var today=new Date(); today.setHours(0,0,0,0);
    st.end=today; st.start=new Date(today.getTime()-6*864e5); st.view=new Date(today.getFullYear(),today.getMonth(),1);
    container.style.cssText="position:absolute;top:calc(100% + 6px);right:0;z-index:60;display:none;background:#0f0f0f;border:1px solid #2a2a2a;box-shadow:0 18px 44px rgba(0,0,0,.6);flex-direction:row";
    var presets=[['hoje','Hoje'],['hoje_ontem','Hoje+Ontem'],['7d','7 dias'],['30d','30 dias'],['ano','Ano'],['max','Máximo']];
    var pBtn="text-align:left;padding:7px 10px;font-size:11px;text-transform:uppercase;letter-spacing:.04em;color:#8a8a8a;background:none;border:none;cursor:pointer;border-radius:6px;font-family:inherit;white-space:nowrap";
    container.innerHTML=
      '<div style="display:flex;flex-direction:column;padding:8px;gap:2px;border-right:1px solid #1e1e1e;min-width:112px">'
        +presets.map(function(o){ return '<button type="button" data-range="'+o[0]+'" style="'+pBtn+'">'+o[1]+'</button>'; }).join('')
      +'</div>'
      +'<div style="padding:12px 14px 10px;width:262px">'
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">'
          +'<button type="button" class="mch-prev" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">‹</button>'
          +'<span class="mch-caltitle" style="font-size:13px;font-weight:600;color:#f5f5f5"></span>'
          +'<button type="button" class="mch-next" style="width:28px;height:28px;background:none;border:none;color:#8a8a8a;cursor:pointer;font-size:20px;line-height:1">›</button>'
        +'</div>'
        +'<div style="display:grid;grid-template-columns:repeat(7,1fr);text-align:center;font-size:10px;text-transform:uppercase;color:#8a8a8a;opacity:.7;margin-bottom:4px"><span>D</span><span>S</span><span>T</span><span>Q</span><span>Q</span><span>S</span><span>S</span></div>'
        +'<div class="mch-grid" style="display:grid;grid-template-columns:repeat(7,1fr);gap:3px"></div>'
        +'<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding-top:9px;border-top:1px solid #1e1e1e">'
          +'<span class="mch-rng" style="font-size:10.5px;color:#8a8a8a"></span>'
          +'<button type="button" class="mch-apply" style="padding:6px 14px;background:#fff200;color:#0a0a0a;border:none;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.04em;cursor:pointer;font-family:inherit">Aplicar</button>'
        +'</div>'
      +'</div>';
    st.grid=container.querySelector('.mch-grid'); st.title=container.querySelector('.mch-caltitle'); st.rng=container.querySelector('.mch-rng');
    function render(){
      var v=st.view; st.title.textContent=MCH_MONTHS[v.getMonth()]+" "+v.getFullYear();
      var first=new Date(v.getFullYear(),v.getMonth(),1), gs=new Date(first.getTime()-first.getDay()*864e5), h="";
      var base="width:100%;height:32px;display:flex;align-items:center;justify-content:center;font-size:12px;background:none;border:none;cursor:pointer;font-family:inherit;border-radius:0;color:#f5f5f5";
      for(var i=0;i<42;i++){ var d=new Date(gs.getFullYear(),gs.getMonth(),gs.getDate()+i); var s=base;
        var outM=d.getMonth()!==v.getMonth();
        if(outM) s+=";color:#4a4a4a";
        var isS=same(d,st.start), isE=same(d,st.end);
        if(st.start&&st.end&&d>=st.start&&d<=st.end&&!isS&&!isE) s+=";background:rgba(255,242,0,.16);color:"+(outM?"#a5852a":"#f5f5f5");
        if((isS||isE)&&st.end) s+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:0";
        if(isS&&!st.end) s+=";background:#fff200;color:#0a0a0a;font-weight:700;border-radius:0";
        if(same(d,today)&&!isS&&!isE) s+=";box-shadow:inset 0 0 0 1px #2a2a2a";
        h+='<button type="button" data-date="'+iso(d)+'" style="'+s+'">'+d.getDate()+'</button>';
      }
      st.grid.innerHTML=h;
      if(st.start){ var e=st.end||st.start; st.rng.textContent=br(st.start)+((st.end&&!same(st.start,st.end))?(' – '+br(e)):''); } else st.rng.textContent="Selecione um período";
      Array.prototype.forEach.call(container.querySelectorAll('button[data-range]'),function(x){ x.style.color=(x.getAttribute('data-range')===dateRange)?'#fff200':'#8a8a8a'; });
    }
    function syncFromRange(){
      var t=new Date(); t.setHours(0,0,0,0); var r=dateRange;
      function set(a,b){ st.start=a; st.end=b; st.view=new Date((b||a||t).getFullYear(),(b||a||t).getMonth(),1); }
      if(r==='hoje') set(t,t);
      else if(r==='hoje_ontem') set(new Date(t.getTime()-864e5),t);
      else if(r==='7d') set(new Date(t.getTime()-6*864e5),t);
      else if(r==='30d') set(new Date(t.getTime()-29*864e5),t);
      else if(r==='mes') set(new Date(t.getFullYear(),t.getMonth(),1),t);
      else if(r==='ano') set(new Date(t.getFullYear(),0,1),t);
      else if(r==='max'){ st.start=null; st.end=null; st.view=new Date(t.getFullYear(),t.getMonth(),1); }
      else if(r&&r.indexOf('~')>0){ var p=r.split('~'); set(new Date(p[0]+'T00:00:00'), new Date(p[1]+'T00:00:00')); }
      else set(new Date(t.getTime()-6*864e5),t);
    }
    function open(o){ st.open=o; container.style.display=o?'flex':'none'; if(o){ syncFromRange(); render(); } }
    toggle.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); open(!st.open); });
    container.addEventListener('click',function(e){
      e.stopPropagation();
      var pre=e.target.closest('button[data-range]');
      if(pre){ open(false); setRange(pre.getAttribute('data-range'), pre.textContent.trim()); return; }
      if(e.target.closest('.mch-prev')){ st.view=new Date(st.view.getFullYear(),st.view.getMonth()-1,1); render(); return; }
      if(e.target.closest('.mch-next')){ st.view=new Date(st.view.getFullYear(),st.view.getMonth()+1,1); render(); return; }
      if(e.target.closest('.mch-apply')){ if(!st.start) return; var en=st.end||st.start; open(false);
        var pk=presetKey(st.start,en);
        if(pk){ setRange(pk, MCH_PRESET_LABEL[pk]); } else { setRange(iso(st.start)+'~'+iso(en), br(st.start)+' - '+br(en)); }
        return; }
      var day=e.target.closest('button[data-date]');
      if(day){ var p=day.getAttribute('data-date').split('-'); var d=new Date(+p[0],+p[1]-1,+p[2]);
        if(!st.start||st.end){ st.start=d; st.end=null; } else { if(d<st.start){ st.end=st.start; st.start=d; } else st.end=d; }
        render(); }
    });
    document.addEventListener('click',function(ev){ if(container.parentNode && !container.parentNode.contains(ev.target)) open(false); });
  })();

  function setKpi(k,val){
    var el=root.querySelector('.mc-kpi[data-k="'+k+'"] .mc-kpi-val');
    if(el) el.textContent=val;
  }

  function renderHoje(d){
    // "Checkout ao vivo" = pessoas ATIVAS no site agora (GA4 realtime)
    $('#mch-hoje-live').textContent=NUM(d.live_checkout||0);
    var siteEl=$('#mch-hoje-site'); if(siteEl) siteEl.textContent=NUM(d.live_checkout||0);
    // carrinhos abandonados: apenas do dia atual (backend filtra por 'hoje')
    var cartN=Number(d.carrinhos_abandonados||0);
    var cartEl=$('#mch-hoje-cart'); if(cartEl) cartEl.textContent=NUM(cartN);
    var cartSub=$('#mch-cart-sub'); if(cartSub) cartSub.textContent=(cartN<=1?'pendente':'pendentes')+' hoje';
    // contador ao vivo (topo) — removido do layout
    var lvTop=$('#mch-live-val'); if(lvTop) lvTop.textContent=NUM(d.live_checkout||0);
    var ckEl=$('#mch-live-checkout'); if(ckEl) ckEl.textContent=NUM(d.live_checkout||0);
  }

  function renderKpis(d){
    var dash=d.dash||{}, ads=d.ads||{};
    setKpi('margem',PCT(dash.margem||0));
    setKpi('spend',BRL(ads.spend||0));
    var roas=ads.spend&&dash.faturamento?(dash.faturamento/ads.spend):0;
    setKpi('roas',(roas).toFixed(2).replace('.',',')+'×');
    setKpi('resultados',NUM(ads.resultados||0));
  }

  /* ===== Card Faturamento (série + gráfico) ===== */
  var EXCL_STATUS={'Cancelado':1,'Devolvido':1,'Não pago':1};
  var _ordersCache={};
  function getOrders(range){
    if(_ordersCache[range]) return _ordersCache[range];
    var pr=call({resource:'orders',range:range}).then(function(res){ return (res&&res.rows)||[]; });
    _ordersCache[range]=pr; return pr;
  }
  var fatState={view:'curve',metric:'faturamento',buckets:[],rows:[],dash:{},ads:{}};
  var METRIC_LABEL={faturamento:'Faturamento',lucro:'Lucro'};

  /* saudação: Olá, <nome do cliente> (mesmo padrão do business-guard) */
  (function(){
    var raw=(root.dataset.customer||'').trim();
    var t=$('#mch-title'); if(!t) return;
    if(raw && raw.indexOf('{{')<0){ t.innerHTML='Olá, <strong>'+esc(raw.toUpperCase())+'</strong>'; }
    else { t.textContent='Midnight Crew'; }
  })();
  var BRLc=function(v){ v=+v||0; var a=Math.abs(v), s=v<0?'-':'';
    if(a>=1e6) return s+'R$ '+(a/1e6).toFixed(1).replace('.',',')+'M';
    if(a>=1e3) return s+'R$ '+(a/1e3).toFixed(1).replace('.',',')+'k';
    return s+'R$ '+a.toFixed(0); };
  function dayKey(d){ return d.getFullYear()+'-'+('0'+(d.getMonth()+1)).slice(-2)+'-'+('0'+d.getDate()).slice(-2); }
  function rangeWindow(range, rows){
    var now=new Date(), to=new Date(now.getFullYear(),now.getMonth(),now.getDate()), from;
    if(range==='hoje') from=new Date(to);
    else if(range==='hoje_ontem') from=new Date(to.getTime()-864e5);
    else if(range==='7d') from=new Date(to.getTime()-6*864e5);
    else if(range==='30d') from=new Date(to.getTime()-29*864e5);
    else if(range==='mes') from=new Date(now.getFullYear(),now.getMonth(),1);
    else if(range==='ano') from=new Date(now.getFullYear(),0,1);
    else if(range==='max'){ var min=null; (rows||[]).forEach(function(o){ var d=o.created_at?new Date(o.created_at):null; if(d&&!isNaN(d)&&(!min||d<min)) min=d; });
      from=min?new Date(min.getFullYear(),min.getMonth(),min.getDate()):new Date(to.getTime()-29*864e5); }
    else if(range&&range.indexOf('~')>0){ var p=range.split('~'); from=new Date(p[0]+'T00:00:00'); to=new Date(p[1]+'T00:00:00'); }
    else from=new Date(to.getTime()-6*864e5);
    return {from:from,to:to};
  }
  function buildSeries(rows, range, field){
    var w=rangeWindow(range, rows), buckets=[];
    var oneDay=dayKey(w.from)===dayKey(w.to);
    if(oneDay){
      var now=new Date(), isToday=dayKey(w.from)===dayKey(now), maxH=isToday?now.getHours():23;
      for(var h=0;h<=maxH;h++) buckets.push({key:h,label:('0'+h).slice(-2)+'h',value:0});
      rows.forEach(function(o){
        if(EXCL_STATUS[String(o.status||'')]) return;
        var d=o.created_at?new Date(o.created_at):null; if(!d||isNaN(d)) return;
        if(dayKey(d)!==dayKey(w.from)) return;
        var b=buckets[d.getHours()]; if(b) b.value+=(+o[field]||0);
      });
    } else {
      var idx={}, cur=new Date(w.from.getFullYear(),w.from.getMonth(),w.from.getDate());
      while(cur<=w.to){ var b={key:dayKey(cur),label:('0'+cur.getDate()).slice(-2)+'/'+('0'+(cur.getMonth()+1)).slice(-2),value:0};
        buckets.push(b); idx[b.key]=b; cur=new Date(cur.getTime()+864e5); }
      rows.forEach(function(o){
        if(EXCL_STATUS[String(o.status||'')]) return;
        var d=o.created_at?new Date(o.created_at):null; if(!d||isNaN(d)) return;
        var b=idx[dayKey(d)]; if(b) b.value+=(+o[field]||0);
      });
    }
    return buckets;
  }
  function sumToday(rows, field){
    var tk=dayKey(new Date()), s=0;
    rows.forEach(function(o){
      if(EXCL_STATUS[String(o.status||'')]) return;
      var d=o.created_at?new Date(o.created_at):null; if(!d||isNaN(d)) return;
      if(dayKey(d)===tk) s+=(+o[field]||0);
    });
    return s;
  }
  function smoothPath(p){
    if(!p.length) return '';
    if(p.length<3) return 'M '+p.map(function(q){return q[0].toFixed(2)+' '+q[1].toFixed(2);}).join(' L ');
    var t=0.16, d='M '+p[0][0].toFixed(2)+' '+p[0][1].toFixed(2);
    for(var i=0;i<p.length-1;i++){
      var p0=p[i-1]||p[i], p1=p[i], p2=p[i+1], p3=p[i+2]||p2;
      var c1x=p1[0]+(p2[0]-p0[0])*t, c1y=p1[1]+(p2[1]-p0[1])*t;
      var c2x=p2[0]-(p3[0]-p1[0])*t, c2y=p2[1]-(p3[1]-p1[1])*t;
      d+=' C '+c1x.toFixed(2)+' '+c1y.toFixed(2)+' '+c2x.toFixed(2)+' '+c2y.toFixed(2)+' '+p2[0].toFixed(2)+' '+p2[1].toFixed(2);
    }
    return d;
  }
  var CHART_COLOR='#fff200';
  var CHART_NEG='#ff4d4d';
  function drawChart(buckets, view){
    var host=$('#mch-fat-chart'); if(!host) return;
    var vals=buckets.map(function(b){return b.value;}), n=vals.length;
    if(!n){ host.innerHTML=''; return; }
    var max=Math.max.apply(null,vals), min=Math.min.apply(null,vals);
    var hasNeg=min<0;
    // com negativos, ancora o domínio no zero pra manter a base dentro da janela
    var dmin=hasNeg?min:min, dmax=hasNeg?Math.max(max,0):max;
    if(dmax===dmin) dmax=dmin+1;
    // folga inferior maior quando há negativos: o vale não fica colado no fundo
    var PT=14, PB=hasNeg?24:10;
    function Y(v){ return (100-PB)-((v-dmin)/(dmax-dmin))*(100-PT-PB); }
    function X(i){ return n<=1?50:(i/(n-1))*100; }
    // base do preenchimento: zero quando há negativos, senão o fundo
    var baseY=hasNeg?Y(0):(100-PB);
    var defs='', zero='', clips='';
    var yz=Y(0);
    if(hasNeg){
      defs='<defs><linearGradient id="mfatZeroGrad" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="100" y2="0">'
        +'<stop offset="0" stop-color="'+CHART_COLOR+'" stop-opacity="0"></stop>'
        +'<stop offset="1" stop-color="'+CHART_COLOR+'" stop-opacity="0.55"></stop></linearGradient>'
        // recortes acima/abaixo da linha do zero
        +'<clipPath id="mfatClipUp"><rect x="0" y="0" width="100" height="'+yz.toFixed(2)+'"></rect></clipPath>'
        +'<clipPath id="mfatClipDown"><rect x="0" y="'+yz.toFixed(2)+'" width="100" height="'+(100-yz).toFixed(2)+'"></rect></clipPath></defs>';
      zero='<line x1="0" y1="'+yz.toFixed(2)+'" x2="100" y2="'+yz.toFixed(2)+'" stroke="url(#mfatZeroGrad)" stroke-width="1" vector-effect="non-scaling-stroke"></line>';
    }
    var svg;
    if(view==='bar'){
      var slot=100/n, bw=Math.max(slot*0.6,1.2);
      var bars=buckets.map(function(b,i){
        var x=slot*i+(slot-bw)/2, y=Y(b.value), y0=baseY;
        var top=Math.min(y,y0), h=Math.max(Math.abs(y0-y),0.4);
        var col=b.value<0?CHART_NEG:CHART_COLOR;
        return '<rect x="'+x.toFixed(2)+'" y="'+top.toFixed(2)+'" width="'+bw.toFixed(2)+'" height="'+h.toFixed(2)+'" fill="'+col+'" opacity="0.85"></rect>';
      }).join('');
      svg='<svg viewBox="0 0 100 100" preserveAspectRatio="none">'+defs+bars+zero+'</svg>';
    } else {
      var pts=buckets.map(function(b,i){return [X(i),Y(b.value)];});
      var line=smoothPath(pts), area=line+' L 100 '+baseY.toFixed(2)+' L 0 '+baseY.toFixed(2)+' Z';
      if(hasNeg){
        // área e linha divididas: amarelo acima do zero, vermelho abaixo
        svg='<svg viewBox="0 0 100 100" preserveAspectRatio="none">'+defs
          +'<path d="'+area+'" fill="'+CHART_COLOR+'" opacity="0.12" clip-path="url(#mfatClipUp)"></path>'
          +'<path d="'+area+'" fill="'+CHART_NEG+'" opacity="0.16" clip-path="url(#mfatClipDown)"></path>'
          +zero
          +'<path d="'+line+'" fill="none" stroke="'+CHART_COLOR+'" stroke-width="2" vector-effect="non-scaling-stroke" stroke-linejoin="round" stroke-linecap="round" clip-path="url(#mfatClipUp)"></path>'
          +'<path d="'+line+'" fill="none" stroke="'+CHART_NEG+'" stroke-width="2" vector-effect="non-scaling-stroke" stroke-linejoin="round" stroke-linecap="round" clip-path="url(#mfatClipDown)"></path>'
          +'</svg>';
      } else {
        svg='<svg viewBox="0 0 100 100" preserveAspectRatio="none">'+defs
          +'<path d="'+area+'" fill="'+CHART_COLOR+'" opacity="0.12"></path>'
          +'<path d="'+line+'" fill="none" stroke="'+CHART_COLOR+'" stroke-width="2" vector-effect="non-scaling-stroke" stroke-linejoin="round" stroke-linecap="round"></path>'
          +'</svg>';
      }
    }
    host.innerHTML=svg;
  }
  function attachHover(buckets){
    var region=$('.mfat-chart-region'), tip=$('#mch-fat-tip'), card=$('#mch-fat-card');
    if(!region||!tip||!card) return;
    region.onmousemove=function(e){
      if(!buckets.length) return;
      var rr=region.getBoundingClientRect(), cr=card.getBoundingClientRect();
      var x=(e.clientX-rr.left)/rr.width;
      var i=Math.round(x*(buckets.length-1)); i=Math.max(0,Math.min(buckets.length-1,i));
      var b=buckets[i];
      tip.innerHTML='<b>'+esc(b.label)+'</b> · '+BRL(b.value);
      var px=(buckets.length<=1?0.5:i/(buckets.length-1))*rr.width;   // x dentro da região
      tip.style.left=((rr.left-cr.left)+px)+'px';                     // relativo ao card (overflow visível)
      tip.style.top=((rr.top-cr.top)+rr.height*0.42)+'px';
      tip.style.opacity='1';
    };
    region.onmouseleave=function(){ tip.style.opacity='0'; };
  }
  /* tooltip descritivo do valor (lucro = mesmo cálculo/breakdown do dashboard) */
  function metricTipHTML(){
    var dash=fatState.dash||{}, ads=fatState.ads||{};
    var fat=+dash.faturamento||0, spend=+ads.spend||0;
    if(fatState.metric==='lucro'){
      var cb=dash.custos_breakdown||{}, net=(+dash.lucro||0)-spend;
      var rows=[['Faturamento',BRL(fat)]];
      if(+cb.cogs>0)        rows.push(['− Produtos (COGS)',BRL(cb.cogs)]);
      if(+cb.embalagem>0)   rows.push(['− Embalagem',BRL(cb.embalagem)]);
      if(+cb.frete>0)       rows.push(['− Frete absorvido',BRL(cb.frete)]);
      rows.push(['− Yampi (taxa fixa)',BRL(cb.taxa_yampi||0)]);
      if(+cb.taxa_appmax>0) rows.push(['− Appmax (processamento)',BRL(cb.taxa_appmax)]);
      if(spend>0)           rows.push(['− Meta Ads',BRL(spend)]);
      return '<div class="tt-h">Lucro (após ads)</div><div class="tt-v" style="color:'+(net<0?'var(--bad)':'var(--good)')+'">'+BRL(net)+'</div>'
        +'<div class="tt-d">'+rows.map(function(r){return '<div class="r"><span>'+r[0]+'</span><span>'+r[1]+'</span></div>';}).join('')+'</div>';
    }
    // faturamento: excluídos (igual ao dashboard)
    var ex=dash.excluidos||{}, lines=[];
    if(+ex.cancelado_count>0) lines.push(['Cancelados/Devolvidos','− '+ex.cancelado_count+' ped.']);
    if(+ex.naopago_count>0)   lines.push(['Não pagos','− '+ex.naopago_count+' ped.']);
    var body=lines.length?('<div class="tt-d">'+lines.map(function(r){return '<div class="r"><span>'+r[0]+'</span><span>'+r[1]+'</span></div>';}).join('')+'</div>'):'';
    return '<div class="tt-h">Faturamento líquido</div><div class="tt-v">'+BRL(fat)+'</div>'+body;
  }
  (function(){
    var head=$('#mch-fat-total'), info=$('#mch-fat-info'), card=$('#mch-fat-card');
    if(!head||!info||!card) return;
    head.addEventListener('mouseenter',function(){
      info.innerHTML=metricTipHTML();
      var cr=card.getBoundingClientRect(), hr=head.getBoundingClientRect();
      var left=hr.left-cr.left; left=Math.min(left, cr.width-232);
      info.style.left=Math.max(4,left)+'px';
      info.style.top=(hr.bottom-cr.top+8)+'px';
      info.style.opacity='1'; info.style.visibility='visible';
    });
    head.addEventListener('mouseleave',function(){ info.style.opacity='0'; info.style.visibility='hidden'; });
  })();
  var ARR_UP='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"><line x1="12" y1="20" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline></svg>';
  var ARR_DOWN='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"><line x1="12" y1="4" x2="12" y2="19"></line><polyline points="5 12 12 19 19 12"></polyline></svg>';
  var ARR_FLAT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="square"><line x1="4" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';
  function renderMetric(){
    var dash=fatState.dash||{}, ads=fatState.ads||{}, rows=fatState.rows||[], field=fatState.metric;
    // lucro = mesmo cálculo do dashboard (lucro dos pedidos − gasto com Ads)
    var total=field==='lucro'?((dash.lucro||0)-(ads.spend||0)):(dash.faturamento||0);
    $('#mch-fat-metric-label').textContent=METRIC_LABEL[field]||'Faturamento';
    $('#mch-fat-total').textContent=BRL(total);
    $('#mch-fat-pedidos').textContent=NUM(dash.pedidos||0)+' pedidos';
    var buckets=buildSeries(rows,dateRange,field);
    fatState.buckets=buckets;
    var vals=buckets.map(function(b){return b.value;});
    var first=vals[0]||0, last=vals.length?vals[vals.length-1]:0;
    var pct=first?((last-first)/first)*100:0;
    var up=pct>0.5, down=pct<-0.5;
    var pctEl=$('#mch-fat-pct');
    if(pctEl){
      pctEl.style.color=up?'var(--good)':down?'var(--bad)':'var(--mut)';
      pctEl.innerHTML=(up?ARR_UP:down?ARR_DOWN:ARR_FLAT)+Math.abs(pct).toFixed(1).replace('.',',')+'%';
    }
    // faturamento/lucro do dia
    var today=sumToday(rows,field), tEl=$('#mch-fat-today');
    tEl.style.color=today>0?'var(--good)':today<0?'var(--bad)':'var(--mut)';
    tEl.textContent=(today>=0?'+':'−')+BRLc(Math.abs(today))+' hoje';
    // stats
    var peak=vals.length?Math.max.apply(null,vals):0, low=vals.length?Math.min.apply(null,vals):0,
        avg=vals.length?vals.reduce(function(a,b){return a+b;},0)/vals.length:0;
    $('#mch-fat-stats').innerHTML=
      '<span><b>'+BRLc(peak)+'</b> pico</span><span class="sep">·</span>'
     +'<span><b>'+BRLc(low)+'</b> baixa</span><span class="sep">·</span>'
     +'<span><b>'+BRLc(avg)+'</b> média</span>';
    drawChart(buckets,fatState.view);
    attachHover(buckets);
  }
  function renderFaturamentoCard(d){
    var card=$('#mch-fat-card'); if(!card) return;
    fatState.dash=d.dash||{};
    fatState.ads=d.ads||{};
    // valor imediato (antes da série carregar)
    var t=fatState.metric==='lucro'?((fatState.dash.lucro||0)-((fatState.ads.spend)||0)):(fatState.dash.faturamento||0);
    $('#mch-fat-total').textContent=BRL(t);
    $('#mch-fat-pedidos').textContent=NUM(fatState.dash.pedidos||0)+' pedidos';
    getOrders(dateRange).then(function(rows){ fatState.rows=rows; renderMetric(); }).catch(function(){});
  }
  /* toggle linha / barra */
  (function(){
    var tg=$('#mch-fat-toggle'); if(!tg) return;
    Array.prototype.forEach.call(tg.querySelectorAll('button'),function(b){
      b.addEventListener('click',function(){
        fatState.view=this.dataset.view;
        Array.prototype.forEach.call(tg.querySelectorAll('button'),function(x){x.classList.remove('is-active');});
        this.classList.add('is-active');
        if(fatState.buckets.length) drawChart(fatState.buckets,fatState.view);
      });
    });
  })();
  /* dropdown métrica: faturamento / lucro */
  (function(){
    var dp=$('#mch-fat-drop'), btn=$('#mch-fat-drop-btn'), menu=$('#mch-fat-drop-menu');
    if(!dp||!btn||!menu) return;
    btn.addEventListener('click',function(e){ e.stopPropagation(); dp.classList.toggle('open'); });
    document.addEventListener('click',function(){ dp.classList.remove('open'); });
    Array.prototype.forEach.call(menu.querySelectorAll('button'),function(b){
      b.addEventListener('click',function(e){
        e.stopPropagation();
        fatState.metric=this.dataset.metric;
        Array.prototype.forEach.call(menu.querySelectorAll('button'),function(x){x.classList.remove('is-active');});
        this.classList.add('is-active');
        dp.classList.remove('open');
        renderMetric();
      });
    });
  })();

  function renderRanking(d){
    var wrap=$('#mch-ranking');
    var rank=(d.dash&&d.dash.ranking)||[];
    if(!rank.length){wrap.innerHTML='<p class="mc-empty">Sem dados</p>';return;}
    var max=rank[0].pedidos||1;
    wrap.innerHTML=rank.map(function(r,i){
      var pct=Math.round((r.pedidos/max)*100);
      return '<div class="mch-rank-row">'
        +'<div class="mch-rank-top">'
          +'<span class="mch-rank-n">'+(i+1)+'</span>'
          +'<span class="mch-rank-nm" title="'+esc(r.nome)+'">'+esc(r.nome)+' <span class="mch-rank-un">'+NUM(r.pedidos)+' un.</span></span>'
          +'<span class="mch-rank-v">R$ '+Math.round(r.receita||0).toLocaleString("pt-BR")+'</span>'
        +'</div>'
        +'<div class="mch-rank-bar-wrap"><div class="mch-rank-bar" style="width:'+pct+'%"></div></div>'
        +'</div>';
    }).join('');
  }

  var STATUS_COLORS={
    'Pago':'#48f91e','Enviado':'#fff200','Entregue':'#48f91e','Não pago':'#ff4d4d',
    'Cancelado':'#ff4d4d','Devolvido':'#f5a623','Não processado':'#8a8a8a','Troca':'#8a8a8a'
  };
  function renderStatus(d){
    var wrap=$('#mch-status');
    // count by status from today's orders - we'll use a rough approach
    wrap.innerHTML='<p class="mc-empty">Calculando...</p>';
    getOrders(dateRange).then(function(rows){
      var counts={};
      rows.forEach(function(o){
        var st=String(o.status||'Desconhecido');
        counts[st]=(counts[st]||0)+1;
      });
      var entries=Object.keys(counts).sort(function(a,b){return counts[b]-counts[a];});
      if(!entries.length){wrap.innerHTML='<p class="mc-empty">Sem pedidos</p>';return;}
      wrap.innerHTML=entries.map(function(st){
        var col=STATUS_COLORS[st]||'#8a8a8a';
        return '<div class="mch-status-row">'
          +'<div class="mch-status-dot" style="background:'+col+'"></div>'
          +'<span class="mch-status-nm">'+esc(st)+'</span>'
          +'<span class="mch-status-v">'+NUM(counts[st])+'</span>'
          +'</div>';
      }).join('');
    }).catch(function(){wrap.innerHTML='<p class="mc-empty">Erro</p>';});
  }

  function renderAlerts(d){
    var alerts=[];
    var dash=d.dash||{};
    if((dash.margem||0)<0.1) alerts.push({icon:'⚠️',cls:'bad',msg:'Margem abaixo de 10% no período.'});
    if((dash.roas||0)<1.5&&(d.ads&&d.ads.spend>0)) alerts.push({icon:'📉',cls:'bad',msg:'ROAS abaixo de 1.5×. Cheque os criativos.'});
    if((d.carrinhos_abandonados||0)>20) alerts.push({icon:'🛒',cls:'',msg:d.carrinhos_abandonados+' carrinhos abandonados pendentes.'});
    if((dash.lucro||0)>0) alerts.push({icon:'✅',cls:'ok',msg:'Lucrativo no período: '+BRL(dash.lucro)+'.'});
    if(!alerts.length){$('#mch-alerts-wrap').style.display='none';return;}
    $( '#mch-alerts-wrap').style.display='';
    $('#mch-alerts').innerHTML=alerts.map(function(a){
      return '<div class="mch-alert '+a.cls+'"><span class="mch-alert-icon">'+a.icon+'</span><span>'+esc(a.msg)+'</span></div>';
    }).join('');
  }

  function renderAll(d){ renderHoje(d); renderKpis(d); renderFaturamentoCard(d); renderRanking(d); renderAlerts(d); renderStatus(d); }
  function load(){
    _ordersCache={};
    var lsKey='mc_home_kpis_'+dateRange;
    try{
      var s=localStorage.getItem(lsKey);
      if(s){ var st=JSON.parse(s); renderAll(st.d); $('#mch-updated').textContent='Cache · atualizando…'; }
      else  { $('#mch-updated').textContent='Carregando...'; }
    }catch(e){ $('#mch-updated').textContent='Carregando...'; }
    call({resource:'home_kpis',range:dateRange}).then(function(d){
      if(d&&d.error){$('#mch-updated').textContent='Erro: '+d.error;return;}
      try{ localStorage.setItem(lsKey,JSON.stringify({ts:Date.now(),d:d})); }catch(e){}
      renderAll(d);
      $('#mch-updated').textContent='Atualizado '+new Date().toLocaleTimeString('pt-BR',{hour:'2-digit',minute:'2-digit'});
    }).catch(function(e){$('#mch-updated').textContent='Erro: '+e.message;});
  }

  function pollLive(){
    // pessoas ativas no site AGORA (GA4 realtime) — alimenta o KPI "Checkout ao vivo" e o topo
    call({resource:'live_checkout'}).then(function(d){
      var n=d&&d.count!=null?d.count:0;
      var lv=$('#mch-live-val'); if(lv) lv.textContent=NUM(n);
      var hs=$('#mch-hoje-site'); if(hs) hs.textContent=NUM(n);
      var c1=$('#mch-live-checkout'); if(c1) c1.textContent=NUM(n);
      var c2=$('#mch-hoje-live'); if(c2) c2.textContent=NUM(n);
    }).catch(function(){});
    clearTimeout(liveTimer);
    liveTimer=setTimeout(pollLive,30000);
  }

  load();
  pollLive();
})();